export default __webpack_public_path__ + "static/media/Hallway.a8c441fe.png";